export default __webpack_public_path__ + "static/media/Bestquality.c5751da0.svg";